import { StateParams } from '@uirouter/core';
import * as angular from 'angular';
import * as _ from 'underscore';
import { ViewportController } from '../../../../../app.common/modules/common/controllers/viewport-typed.controller';
import { EnumService } from '../../../../../app.common/modules/common/services/enum.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { TransferFileService } from '../../../../../app.common/modules/common/services/transferFile.service';
import { SalesAssistantFeedbackStats, SalesAssistantItem, SalesAssistantPagingSettings } from '../../../core/index';
import { IRetailerRootScope } from '../../../core/models';
import { JispPayService } from '../../../jispPay/jispPay.service';
import { StaffRatingService } from '../../staffRating.service';

interface IStaffRatingAnalyticsViewModel {
    AllowViewRating: boolean;
    AverageRating: number;
    FeedbackCount: number;
    LastUpdate: Date;
}

class StaffRatingListComponent extends ViewportController {

    public static $inject = ['$rootScope', '$scope', '$window', '$stateParams', '$q', '$timeout',
        'popupService', 'notificationService', 'staffRatingService', 'enumService', 'jispPayService', 'transferFileService', '$translate'];

    public total: number;
    public data: SalesAssistantItem[] = [];
    public dataSummary: SalesAssistantFeedbackStats = {};
    public waiting: boolean;
    public isScrollLoad: boolean = true;
    public sortCounter: number = 0;
    public prevSortColumn: string = 'Name';
    public skipWatch: boolean = false;

    public settings = {
        pageSize: 10,
        currentPage: 0,
        sort: this.staffRatingService.getColumnSort(),
        isStaffAny: {
            active: null,
            archived: false
        },
        filter: {
            isActive: true
        },
        getFilter: (): SalesAssistantPagingSettings => {
            const i = this.settings;
            return {
                Limit: i.pageSize,
                Offset: (i.currentPage - 1) * i.pageSize,
                SortColumn: i.sort.column,
                SortOrder: i.sort.order as SalesAssistantPagingSettings.SortOrderEnum,
                IsActive: i.filter.isActive
            };
        }
    };

    constructor(
        private $rootScope: IRetailerRootScope,
        private $scope: ng.IScope,
        private $window: ng.IWindowService,
        private $stateParams: StateParams,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private popupService: PopupService,
        private notificationService: NotificationService,
        protected staffRatingService: StaffRatingService,
        private enums: EnumService,
        private jispPayService: JispPayService,
        public transferFileService: TransferFileService,
        private $translate: angular.translate.ITranslateService

    ) {
        super($rootScope);
        this.init();
    }

    public getAvatarUrl(id: number): string {
        return (id)
            ? this.jispPayService.getAvatarUrl(id, 48, 48)
            : '';
    }

    public exportCsv() {
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        const params = this.getParams(0, 0) as SalesAssistantPagingSettings;
        const fileName = 'Staff-rating_' + this.getFormatedDate(new Date());
        const promise = this.staffRatingService.getSalesAssistantCsv(params);
        this.handlePromise(promise).then((file) => {
            this.transferFileService.transferFile(file, fileName, this.enums.ExportFileType.CSV);
            this.notificationService.clearAll();
        });
    }

    private getFormatedDate(date: Date) {
        return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear() + '-'
            + ('0' + date.getHours()).slice(-2) + '-' + ('0' + date.getMinutes()).slice(-2) + '-' + ('0' + date.getSeconds()).slice(-2);
    }

    private handlePromise<T>(promise: ng.IPromise<T>): ng.IPromise<T> {
        this.waiting = true;

        promise
            .catch((error) => this.notificationService.showErrorMessage(error))
            .finally(() => this.waiting = false);

        return promise;
    }

    private getParams(offset: number, limit: number): any {
        return {
            Offset: offset,
            Limit: limit,
            SortOrder: this.settings.sort.order as SalesAssistantPagingSettings.SortOrderEnum,
            SortColumn: this.settings.sort.column,
            IsArchive: !this.settings.filter.isActive
        };
    }

    private loadMore = async () => {
        if (this.waiting) {
            return;
        }
        this.isScrollLoad = true;
        await this.getData();

    }

    private init = async () => {
        this.getData();
        this.getSummaryData();
        this.$scope.$watchGroup(['vm.settings.sort.column', 'vm.settings.sort.order', 'vm.settings.filter.isActive'], (n: any, o: any) => {
            if (this.skipWatch) {
                this.skipWatch = false;
                return;
            }
            this.settings.currentPage = 1;
            this.isScrollLoad = false;
            if (this.prevSortColumn !== n[0]) {
                this.sortCounter = 0;
            }
            if (this.settings.sort.column !== 'Name') {
                this.sortCounter++;
            }
            if (this.sortCounter === 3) {
                this.settings.sort.column = 'Name';
                this.settings.sort.order = this.settings.sort.asc;
                this.sortCounter = 0;
                this.skipWatch = true;
            }
            this.prevSortColumn = n[0];
            if (n && n !== o) {
                this.getData();
                this.getSummaryData();
            }

        });
    }

    private async getData() {
        this.waiting = true;
        this.jispPayService.isStaffAny(true).then((result: any) => {
            this.settings.isStaffAny.active = result;
        });
        this.jispPayService.isStaffAny(false).then((result: any) => {
        this.settings.isStaffAny.archived =  result;
        });

        const filter = this.settings.getFilter();
        const data = await this.staffRatingService.getStaffRatingData(filter);

        _.forEach(data.Items as SalesAssistantItem[], (staff) => {
            staff.AvatarUrl = this.getAvatarUrl(staff.AvatarID);
        });
        if (this.isScrollLoad) {
            this.data = this.data.concat(data.Items);
        } else {
            this.data = data.Items;
        }
        console.log(this.data);
        this.total = data.Total;

        this.settings.currentPage++;
        this.waiting = false;
    }

    private async getSummaryData() {
        const data = await this.staffRatingService.getStaffRatingSummary( !this.settings.filter.isActive);
        this.dataSummary = data;
        console.log(data);
    }
}

angular
    .module('naut').component('staffRatingList', {
        template: require('./staffRatingList.component.html'),
        controller: StaffRatingListComponent,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/staffRating/components/list/staffRatingList.component.ts